import { deriveEffectiveGeometryConfig } from '@/workflow/_pure/config/geometryConfig';
import type { BaseConfig } from '@/workflow/_contract/config';

const effectiveGeometryConfigBySource = new WeakMap<BaseConfig, BaseConfig>();

export function resolveEffectiveGeometryConfig<TConfig extends BaseConfig>(config: TConfig): TConfig {
    let effective = effectiveGeometryConfigBySource.get(config);
    if (!effective) {
        effective = deriveEffectiveGeometryConfig(config);
        effectiveGeometryConfigBySource.set(config, effective);
    }
    return effective as TConfig;
}
